<template>
  <div class="security-methods-selection">
    <base-header type class="rsgradient pb-3 pb-1 pt-3 pt-md-5" />
    <b-card class="text-center">
      <b-card-body>
        <div class="col-md-12 text-center">
          <form autocomplete="off">
            <div v-show="showNewPin">
              <div class="row form-group">
                <div class="col-md-12 text-center">
                  <img
                    src="/img/icons/verificado.png"
                    class="rounded-circle"
                    style="width: 150px; cursor: pointer"
                    alt
                  />
                </div>
              </div>
              <div class="row form-group">
                <div
                  class="col-md-12 text-center"
                >Configurá una capa extra de seguridad en tu cuenta</div>
                <div
                  class="col-md-12 text-center"
                >Registrá una clave numérica (PIN) de {{length}} dígitos para operaciones que impliquen egresos de dinero como Pagos con QR o Transferencias</div>
              </div>
              <div class="col-md-12 text-center title">Ingresá un PIN de {{length}} dígitos</div>
              <div>
                <base-input class="userName" value="newpinuser" autocomplete="off" hidden />
              </div>
              <pincode-input
                v-model="newPin"
                ref="pincode-new-pin"
                secure
                autocomplete="off"
                :length="this.length"
              />
            </div>
            <div v-show="showRepeatNewPin">
              <div class="col-md-12 text-center">
                <img
                  src="/img/icons/verificado.png"
                  class="rounded-circle"
                  style="width: 150px; cursor: pointer"
                  alt
                />
              </div>
              <div
                class="col-md-12 text-center title"
                style="margin-top:20px"
              >Reingresá un PIN de {{length}} dígitos</div>
              <div>
                <base-input class="userName" value="repeatnewpinuser" autocomplete="off" hidden />
              </div>
              <pincode-input
                v-model="repeatNewPin"
                ref="pincode-repeat-new-pin"
                secure
                autocomplete="off"
                :length="this.length"
              />
              <div
                class="col-md-12 text-center"
              >Repetí el PIN ingresado asi nos aseguramos que esté correcto</div>
            </div>
            <div v-show="showResultOK">
              <div
                class="col-md-12 text-center title"
                style="margin-bottom:20px"
              >¡Listo! Tu clave PIN de {{length}} dígitos quedó registrada</div>
              <span>
                <i class="fa fa-fw fa-key" style="font-size:120px" />
              </span>
              <div
                class="col-md-12 text-center"
                style="margin-top:20px"
              >No la divulgues y recordá que solo te la vamos a pedir cuando realices una operación de egreso de dinero como Pagos con QR o Transferencias</div>
            </div>
          </form>
        </div>
        <div class="row" style="margin-top:40px">
          <div class="col-md-12 text-center" v-if="showResultOK">
            <b-button class="btn btn-danger" @click="goToAfterFinish">Finalizar</b-button>
          </div>
          <div class="col-md-12 text-center" v-else>
            <b-button class="btn btn-danger" @click="nextStep">Siguiente</b-button>
          </div>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<style lang="scss">
.title {
  color: #ff5855;
  font-weight: bold;
}
</style>


<script>
import PincodeInput from "vue-pincode-input";
import generalHelpers from "@/helpers/generalHelpers";
import axiosHelpers from "@/helpers/axiosHelpers";
import notificationHelpers from "@/helpers/notificationHelpers";

export default {
  name: "SecurityMethodsSelection",
  components: {
    "pincode-input": PincodeInput
  },
  data() {
    return {
      length: 6,
      step: 0,
      newPin: "",
      repeatNewPin: ""
    };
  },
  computed: {
    showNewPin() {
      return this.step == 0;
    },
    showRepeatNewPin() {
      return this.step == 1;
    },
    showResultOK() {
      return this.step == 2;
    }
  },
  methods: {
    nextStep() {
      let context = this;
      if (context.step == 0) {
        if (context.validatePin(context, context.newPin)) {
          context.step++;
        }
      } else if (context.step == 1) {
        if (context.validatePin(context, context.repeatNewPin)) {
          context.setPinAccountValidation(context);
        }
      }
    },
    goToAfterFinish() {
      let context = this;

      context.$router.push("dashboard");
    },
    validatePin(context, pin) {
      if (pin == "") {
        notificationHelpers.showError(
          "Error",
          "Debe ingresar un Pin de Pago.",
          context
        );
        return false;
      }

      if (pin.length != context.length) {
        notificationHelpers.showError(
          "Error",
          "Debe ingresar un Pin de " + context.length + " dígitos.",
          context
        );
        return false;
      }

      if (generalHelpers.validateSameCharsInString(pin)) {
        notificationHelpers.showError(
          "Error",
          "No pueden ser iguales todos los caracteres del Pin de Pago.",
          context
        );
        return false;
      }

      return true;
    },
    setPinAccountValidation(context) {
      if (context.repeatNewPin != context.newPin) {
        notificationHelpers.showError(
          "Error",
          "El pin y su confirmacion no concuerdan",
          context
        );
        context.cleanNewPin();
        context.cleanRepeatNewPin();
        context.step = 0;
        return;
      }

      context.setPinAccount(context);
    },
    setPinAccount(context) {
      let req = {
        LastPin: "",
        NewPin: context.newPin,
        ActivatePin: context.activatePin
      };

      axiosHelpers.axiosPost(
        "Account/SetInitialPinAccount",
        req,
        context,
        function(data) {
          if (data.ResponseVM.Result) {
            context.$store.dispatch(
              "AccountSetUsePaymentPin",
              data.ResponseVM.Result
            );
            context.step++;
          }
        }
      );
    },
    cleanNewPin() {
      if (this.$refs["pincode-new-pin"] != undefined) {
        this.$refs["pincode-new-pin"].letters.forEach(l => {
          l.value = "";
        });
      }

      this.newPin = "";
    },
    cleanRepeatNewPin() {
      if (this.$refs["pincode-repeat-new-pin"] != undefined) {
        this.$refs["pincode-repeat-new-pin"].letters.forEach(l => {
          l.value = "";
        });
      }

      this.RepeatNewPin = "";
    }
  }
};
</script>